import { useEffect, useState } from "react";
import { MODELOS_PROMOCAO } from "../promocoes-modelos";
import { IconClose, IconTrendUp, IconCheck, IconFile, IconShield } from "../icons";

/**
 * GUIA "Modelos de promoção" — a política de promoção da SERCAMP na tela, sem
 * precisar abrir um registro.
 *
 * Layout mestre-detalhe (mesma ideia do Guia de Benefícios do DP): a lista das
 * formas de promover à esquerda e, à direita, o caminho escolhido por inteiro —
 * quando usar, o que muda no cadastro, o reajuste praticado, a carência, os
 * critérios, o que comprovar e quem assina.
 *
 * É o material que o RH usa para responder "o que eu preciso fazer para ser
 * promovido?" — e que o gestor lê antes de pedir a promoção de alguém.
 */
export default function ModelosPromocaoModal({ onClose }: { onClose: () => void }) {
  const [ativo, setAtivo] = useState(MODELOS_PROMOCAO[0]!);

  useEffect(() => {
    const onKey = (e: KeyboardEvent) => {
      if (e.key === "Escape") onClose();
    };
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, [onClose]);

  return (
    <div className="modal-overlay" onMouseDown={onClose}>
      <div className="modal-card guia-card" onMouseDown={(e) => e.stopPropagation()}>
        <div className="modal-head">
          <h3>
            <IconTrendUp size={18} /> Modelos de promoção — como se cresce na SERCAMP
          </h3>
          <button type="button" className="icon-btn" onClick={onClose}>
            <IconClose size={18} />
          </button>
        </div>

        <div className="guia-corpo">
          <nav className="guia-menu">
            {MODELOS_PROMOCAO.map((m) => (
              <button
                key={m.key}
                type="button"
                className={`guia-item ${ativo.key === m.key ? "ativo" : ""}`}
                onClick={() => setAtivo(m)}
              >
                <strong>{m.nome}</strong>
                <span>{m.resumo}</span>
              </button>
            ))}
          </nav>

          <div className="guia-detalhe">
            <h4>{ativo.nome}</h4>
            <p className="guia-resumo">{ativo.resumo}</p>

            <div className="guia-fatos">
              <div>
                <span className="guia-rotulo">O que muda no cadastro</span>
                <p>{ativo.efeito}</p>
              </div>
              <div>
                <span className="guia-rotulo">Reajuste praticado</span>
                <p>{ativo.reajuste}</p>
              </div>
              <div>
                <span className="guia-rotulo">Carência</span>
                <p>{ativo.carencia}</p>
              </div>
              <div>
                <span className="guia-rotulo">Quem aprova</span>
                <p>{ativo.aprovacao}</p>
              </div>
            </div>

            <section className="guia-secao">
              <h5>
                <IconCheck size={16} /> Critérios — o que precisa estar cumprido
              </h5>
              <ul className="guia-lista">
                {ativo.criterios.map((c) => (
                  <li key={c}>{c}</li>
                ))}
              </ul>
            </section>

            <section className="guia-secao">
              <h5>
                <IconFile size={16} /> Como comprovar
              </h5>
              <ul className="guia-lista">
                {ativo.evidencias.map((e) => (
                  <li key={e}>{e}</li>
                ))}
              </ul>
            </section>

            <p className="guia-nota">
              <IconShield size={14} /> Ao registrar a promoção, marque este modelo no
              formulário: os critérios acima viram uma lista de marcação e ficam gravados
              junto com o registro.
            </p>
          </div>
        </div>

        <div className="modal-foot">
          <span className="muted">
            {MODELOS_PROMOCAO.length} formas de promover · política do RH da SERCAMP
          </span>
          <button type="button" className="btn-primary" onClick={onClose}>
            Fechar
          </button>
        </div>
      </div>
    </div>
  );
}
